import AppService from "./../../../../modules/Appointments/service";

class DBBContractOptionsLoader {
  constructor() {
    if (DBBContractOptionsLoader._instance) {
      return DBBContractOptionsLoader._instance;
    }

    DBBContractOptionsLoader._instance = this;

    this.isLoading = false;
    this.options = null;
    this.promises = [];
  }

  getContractOptions() {
    return new Promise((resolve, reject) => {
      this.promises.push({ resolve, reject });
      this.load();
    });
  }

  load() {
    if (this.options) return this.resolvePromises();

    if (!this.isLoading) {
      this.isLoading = true;
      Promise.all([AppService.getDBBLeaseCompanies(), AppService.getDBBStorageLocations()])
        .then(([leaseCompaniesResult, storageLocationsResult]) => {
          const leaseCompanies = leaseCompaniesResult?.data?.data?.lease_companies;
          const storageLocations = storageLocationsResult?.data?.data?.storage_locations;

          if (!Array.isArray(leaseCompanies) || !Array.isArray(storageLocations)) throw new Error("invalid response when loading DBB contract dropdowns options");

          this.options = {
            leaseCompanyOptions: leaseCompanies.map(leaseCompany => ({ key: leaseCompany.id, value: leaseCompany.id, text: leaseCompany.name })),
            storageLocationOptions: storageLocations.map(storageLocation => ({
              key: storageLocation.id,
              value: storageLocation.id,
              text: storageLocation.name,
              description: storageLocation.sub_location_name,
            })),
          };

          this.resolvePromises();
          this.isLoading = false;
        })
        .catch(err => {
          if (err?.response?.data?.errors?.length) this.rejectPromises(err.response.data.errors[0]);
          else this.rejectPromises(err.message);

          this.isLoading = false;
        });
    }
  }

  rejectPromises(err) {
    let promise;
    while ((promise = this.promises.shift()) !== undefined) {
      promise.reject(err);
    }
  }

  resolvePromises() {
    let promise;
    while ((promise = this.promises.shift()) !== undefined) {
      promise.resolve(this.options);
    }
  }
}

const DBBContractOptions = new DBBContractOptionsLoader();

export default DBBContractOptions;
